module.exports = __webpack_public_path__ + "static/media/half.17e3c7e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/bucket-row/half.svg
// module id = 377
// module chunks = 0